import { groupMembersForCancellation } from '../utils/bookingGroupCancellation.js';

export default function CancellationParticipantPicker({
  booking,
  selectedRegistrationIds,
  onChange,
  idPrefix = 'cancel-participant'
}) {
  const members = groupMembersForCancellation(booking);
  if (members.length <= 1) return null;

  const selected = new Set((selectedRegistrationIds || []).map((id) => String(id)));

  const toggle = (registrationId, checked) => {
    const id = Number(registrationId);
    if (!Number.isFinite(id)) return;
    const next = new Set(selected);
    if (checked) next.add(String(id));
    else next.delete(String(id));
    onChange([...next].map(Number));
  };

  return (
    <div className="dashboard-cancel-participants">
      <p className="dashboard-cancel-label">
        Participants to cancel <span className="dashboard-cancel-required">*</span>
      </p>
      <p className="dashboard-cancel-participants-hint">
        Your group paid together online. Select who should be included in this cancellation request.
      </p>
      <ul className="dashboard-cancel-participants-list">
        {members.map((member) => {
          const regId = Number(member.registrationId);
          const inputId = `${idPrefix}-${regId}`;
          return (
            <li key={regId}>
              <label className="dashboard-cancel-participant-option" htmlFor={inputId}>
                <input
                  id={inputId}
                  type="checkbox"
                  checked={selected.has(String(regId))}
                  onChange={(e) => toggle(regId, e.target.checked)}
                />
                <span>{member.name}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
